import { ReactNode } from 'react'
import { addHttp } from '@common/helpers/helpers'
import { AtlasObjectDetailFormat, IAtlasObjectDetailField } from '@common/interfaces/atlasObjects'
import { formatDate, formatPercent, formatPrice } from '../../helpers/helpers'
import Text from '../Common/Text'
import styles from './AtlasPreviewFields.module.scss'

const formatFieldValue = ({ value, format }: IAtlasObjectDetailField): ReactNode => {
  const text = String(value)

  switch (format) {
    case AtlasObjectDetailFormat.Date:
      return formatDate(text)
    // To the cent when there are cents, as the client page shows a balance; whole otherwise.
    case AtlasObjectDetailFormat.Currency:
      return `$${formatPrice(value, Number.isInteger(Number(value)) ? 0 : 2)}`
    case AtlasObjectDetailFormat.Percent:
      return formatPercent(Number(value))
    case AtlasObjectDetailFormat.Email:
      return <a href={`mailto:${text}`}>{text}</a>
    case AtlasObjectDetailFormat.Phone:
      return <a href={`tel:${text}`}>{text}</a>
    case AtlasObjectDetailFormat.Url:
      return (
        <a href={addHttp(text)} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      )
    default:
      return text
  }
}

interface IProps {
  fields: IAtlasObjectDetailField[]
}

const AtlasPreviewFields = ({ fields }: IProps) => {
  if (!fields.length) {
    return (
      <Text variant="bodyLg" tone="secondary" className={styles.message}>
        No details on file yet.
      </Text>
    )
  }

  return (
    <dl className={styles.fields}>
      {fields.map((field) => {
        const isLongText = field.format === AtlasObjectDetailFormat.LongText
        return (
          <div
            key={field.label}
            className={isLongText ? styles.fieldStacked : styles.field}
            data-cy="atlas-preview-field"
          >
            <dt className={styles.fieldLabel}>{field.label}</dt>
            <dd className={isLongText ? styles.fieldLongText : styles.fieldValue}>
              {formatFieldValue(field)}
            </dd>
          </div>
        )
      })}
    </dl>
  )
}

export default AtlasPreviewFields
